// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ImagensServicos_UploadFotoAjaxInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/imagens_servicos/upload_foto_ajax/{compromisso_servico_id}/{antes_ou_depois}
 *
 * Validates multipart upload for the Vue wizard "upload photo" action.
 * The path parameters (compromisso_servico_id, antes_ou_depois) are validated
 * by the controller. The body is a multipart form containing the `imagem_nome`
 * file field, mirrored into `$_FILES['imagem_nome']` server-side.
 */
import { registerContract } from './validate'

export interface ImagensServicos_UploadFotoAjaxInput {
_files: unknown[]
}

registerContract('ImagensServicos_UploadFotoAjaxInput', {
  _files: { type: 'array',   required: true },
})
